import React from 'react';

export interface Props {
  className?: string;
}

const Tier32: React.FC<Props> = ({ className }) => (
  <svg
    className={className}
    width="12"
    height="10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      d="M11.126 3.126L10.01 8.688a.45.45 0 01-.441.362H2.431a.45.45 0 01-.44-.362L.874 3.126a.3.3 0 01.435-.324L4.03 4.25 5.73.63a.3.3 0 01.543 0l1.697 3.62 2.721-1.448a.3.3 0 01.436.324z"
    ></path>
  </svg>
);
Tier32.displayName = 'Tier32';

export default Tier32;
